import api from '@/services/api';

import { type MaturityModelOption } from '../types';

const BASE_URL = 'maturityModelOptions';

export const getMaturityModelOptions = async () => {
  return await api.get<MaturityModelOption[]>(BASE_URL);
};

export const getMaturityModelOption = async (id: number) => {
  return await api.get<MaturityModelOption>(`${BASE_URL}/${id}`);
};

export const updateMaturityModelOption = async (data: MaturityModelOption) => {
  await api.put(`${BASE_URL}/${data.idMaturityOption}`, data);
  return data;
};

export const createMaturityModelOption = async (option: MaturityModelOption) => {
  return await api.post<MaturityModelOption>(BASE_URL, option);
};

export const deleteMaturityModelOption = async (id: number) => await api.delete(`${BASE_URL}/${id}`);
